import { FormattedMessage } from "react-intl";

import { ButtonProps, Button } from "ui/Button/Button";

import { usePickingActions } from "../hooks/usePickingActions";

type GoToAssignShelvesButtonProps = {
  isButtonDisabled?: boolean;
  onValidateContinue?: () => boolean;
} & ButtonProps;

export function GoToAssignShelvesButton({
  isButtonDisabled = false,
  onValidateContinue = () => true,
  ...rest
}: GoToAssignShelvesButtonProps) {
  const { goToAssignShelves } = usePickingActions();

  return (
    <Button
      isDisabled={isButtonDisabled}
      onClick={() => {
        if (onValidateContinue()) {
          goToAssignShelves();
        }
      }}
      size="lg"
      isFullWidth
      data-testid="redirect-to-assign-shelves-button"
      {...rest}
    >
      <FormattedMessage id="components.picking.go-to-assign-shelves.button-label-assign-shelf" />
    </Button>
  );
}
